import { useNavigate } from "@tanstack/react-router"
import { getRefreshToken } from "./refreshTokenStorage"
import { useLogoutMutation } from "./api"
import { clearAuth } from "./slice"
import useLocale from "@/base/routing/useLocale"
import { useDispatch } from "@/base/store"
import baseApi from "@/base/baseApi"

export default () => {
  const [logout] = useLogoutMutation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const locale = useLocale()

  return async () => {
    // Land on the public home (avoids storing a post-login redirectUrl)
    await navigate({ to: "/$locale", params: { locale } })
    const refreshToken = getRefreshToken()
    if (refreshToken) {
      await logout(refreshToken)
    }
    dispatch(clearAuth())
    dispatch(baseApi.util.resetApiState())
  }
}
